export default "<h1>Installation 安装</h1>\n<p>2O3T 致力于提供给程序员愉悦的开发体验。</p>\n"